import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import EditableInput from '../../components/EditableInput';
import EditableSelect from './../../components/EditableSelect';
import UneditableInput from '../../components/UneditableInput';

import { getLoopsData, updateLoop } from '../../services/loop';
import { showAlert } from '../../store/ducks/alert';

import { Button, CircularProgress } from '@material-ui/core';
import { Save } from '@material-ui/icons';

const LoopLinksInformation = props => {
  const dispatch = useDispatch();
  const [loopLink, setLoopLink] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    displayLoopLink();
  }, []);

  const handleUpdate = async e => {
    e.preventDefault();

    try {
      await updateLoop(loopLink.id, loopLink);
      console.log(loopLink.id);
      dispatch(showAlert('success', 'Loop Link has been updated! 🔥'));
    } catch (error) {
      dispatch(showAlert('error', 'Error! We could not update the Loop Link. 😔'));
      console.log(error);
    }
  };

  const displayLoopLink = async () => {
    const loopLinkId = props.match.params.id;
    try {
      setIsLoading(true);
      const { data } = await getLoopsData(0, { searchItem: 'id', search: loopLinkId });

      setLoopLink(data.rows[0]);

      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', 'Ops! We could not load this Loop Link. 😔'));
      console.log(error);
    }
  };

  const editable = ['type', 'label', 'url', 'order', 'style'];

  const select = ['enabled'];

  const uneditable = ['id', 'channelId', 'createdAt', 'updatedAt', 'deletedAt'];

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="page-header">
        <h1>{loopLink.label}</h1>
      </div>

      <section className="update-section">
        <h3>Edit Loop Link</h3>
        <form onSubmit={handleUpdate} className="update-form">
          <div className="form-fields">
            <EditableInput data={loopLink} setData={setLoopLink} labels={editable} />
            <EditableSelect data={loopLink} setData={setLoopLink} labels={select} />
            <EditableSelect data={loopLink} setData={setLoopLink} labels={['deletedAt']} isDeletedAt />
            <UneditableInput data={loopLink} labels={uneditable} />
          </div>
          <Button type="submit" className="update-btn" variant="contained" startIcon={<Save />}>
            Update Loop Link
          </Button>
        </form>
      </section>
    </>
  );
};

export default LoopLinksInformation;
